window.jQuery = $;

// $(document).ready(function () {
    let $this = $('.select');

    $this.val($this.data('value'));

    let $styledSelect = $('div.select-styled');

    let $list = $('.select-options')
    let $listItems = $list.children('li');

    let $divParent = $this.parent();

    let $tags = $('.tags span');

    const selected_tags = new Set();

    $tags.each((index, tag) => {
        if ($(tag).hasClass('active')) {
            selected_tags.add($(tag).attr('rel'));
        }
    })

    $tags.click(e => {
        const $tag = $(e.currentTarget);
        $tag.toggleClass('active');
        const val = $tag.attr('rel');
        if ($tag.hasClass('active')) {
            selected_tags.add(val);
        } else {
            selected_tags.delete(val);
        }
    })

    $styledSelect.click(function(e) {
        e.stopPropagation();
            
        $('div.select-styled.active').not(this).each(function(){
            $(this).removeClass('active').next('ul.select-options').hide();
        });

        $divParent.toggleClass("active");

        $(this).toggleClass('active').next('ul.select-options').toggle();
    });

    $listItems.click(function(e) {
        $styledSelect.text($(this).text()).removeClass('active');
        $this.val($(this).attr('rel'));
        $list.hide();
        $divParent.removeClass("active");
    });

    $(document).click(function() {
        $styledSelect.removeClass('active');
        $list.hide();
        $divParent.removeClass("active");
    });


    $('#filter-submit').click(e => {
        const filter = {
            type: $this.val(),
            tags: Array.from(selected_tags).join(','),
            q: $('#search-input').val()
        }

        const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');

        const url = `${window.location.href.replace(window.location.search, '')}?${queryString}`;

        window.location.href = url;
    });

    $('.page-news-container').on('click', '.more-news', function(e) {
        e.preventDefault();
        const $this = $(e.currentTarget);
        const href = $this.attr('href').replace('[[page]]', window.current_page + 1);
        $.get(href, function(news) {
            $('#cards-cotainer').append(news);
            window.current_page++;
            if (window.current_page === window.total_pages) {
                $('.page-news-container .more-news').hide();
            }
        })
    });

// });
